import React from "react";
import { Icon } from "antd";
import { Whitelabel } from "../WhitelabelThemesProvider";

type Props = {
  whitelabel: Whitelabel;
  sizeIcon?: number;
};
const WhiteLabelAvatar: React.FC<Props> = ({
  whitelabel,
  sizeIcon = 18,
}) => {
  const icon = whitelabel.favicon;
  const name = whitelabel.name ?? whitelabel.fullName ?? whitelabel.alias;
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      {icon ? (
        <img
          src={icon}
          style={{
            width: sizeIcon,
            height: sizeIcon,
            objectFit: "contain",
            marginRight: 5,
            borderRadius: 4,
          }}
          alt={whitelabel.alias}
        />
      ) : (
        <Icon
          type="appstore"
          style={{
            marginRight: 5,
            fontSize: sizeIcon,
          }}
        />
      )}
      {name}
    </span>
  );
};

export default WhiteLabelAvatar;
